// extracted by mini-css-extract-plugin
export var containerMain = "about-module--containerMain--dd96b";
export var containerCenter = "about-module--containerCenter--47723";
export var card = "about-module--card--f9dd8";
export var groupImage = "about-module--groupImage--c50e9";
export var eventImage = "about-module--eventImage--21214";